import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setIsMobile } from "store/reducers/livestreamSettings";

export const useMobileDetect = () => {
  const dispatch = useDispatch();
  const [isMobile, setIsMobileState] = useState(false);

  useEffect(() => {
    const detectMobile = () => {
      if (typeof window === "undefined") return;
      const smallScreen = window.innerWidth < 1024;
      setIsMobileState(smallScreen);
      dispatch(setIsMobile(smallScreen));
    };
    detectMobile();
    window.addEventListener("resize", detectMobile);
    return () => {
      window.removeEventListener("resize", detectMobile);
    };
  }, []);

  return isMobile;
};
